import React, { useState, useEffect } from "react";
import { List, ChevronDown, ChevronRight, Hash } from "lucide-react";

export function TableOfContents({ headings = [], activeId = "" }) {
  const [isOpen, setIsOpen] = useState(true);

  if (!headings || headings.length === 0) return null;

  const handleScrollTo = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      const topOffset = 100;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - topOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  const renderHeadingItem = (item) => {
    const isActive = activeId === item.id;
    // Indentation based on heading level: H1 -> level 1, H2 -> level 2, H3 -> level 3, H4 -> level 4
    const indentClass =
      item.level === 1
        ? "pl-2 font-bold text-gray-900"
        : item.level === 2
        ? "pl-6 font-semibold text-gray-800"
        : item.level === 3
        ? "pl-10 text-gray-600 text-xs"
        : "pl-14 text-gray-500 text-xs";

    return (
      <li key={item.id} className="relative py-1">
        <a
          href={`#${item.id}`}
          onClick={(e) => handleScrollTo(e, item.id)}
          className={`flex items-start gap-1.5 transition-all duration-200 hover:text-brand-primary ${indentClass} ${
            isActive ? "text-brand-primary font-bold" : ""
          }`}
        >
          {item.level === 1 ? (
            <Hash className="w-3.5 h-3.5 mt-0.5 text-brand-primary flex-shrink-0" />
          ) : (
            <span
              className={`w-1.5 h-1.5 rounded-full mt-1.5 flex-shrink-0 transition-colors ${
                isActive ? "bg-brand-primary scale-125" : "bg-gray-300"
              }`}
            />
          )}
          <span className="leading-snug">{item.text}</span>
        </a>
      </li>
    );
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-5 mb-8 transition-all duration-300">
      <div
        className="flex items-center justify-between cursor-pointer select-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center gap-2 font-heading font-bold text-gray-900 text-base">
          <List className="w-4 h-4 text-brand-primary" />
          Table of Contents
          <span className="text-xs font-normal text-gray-400 bg-gray-100 px-2 py-0.5 rounded-full">
            {headings.length} sections
          </span>
        </div>
        <button
          type="button"
          className="text-gray-400 hover:text-gray-600 p-1 rounded-lg"
          aria-label="Toggle Table of Contents"
        >
          {isOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </button>
      </div>

      {isOpen && (
        <nav className="mt-4 pt-4 border-t border-gray-100">
          <ul className="space-y-0.5 text-sm divide-y divide-gray-50/50">
            {headings.map(renderHeadingItem)}
          </ul>
        </nav>
      )}
    </div>
  );
}

export default TableOfContents;
